import * as openpass from "./src/main";

export * from "./src/main";
export default openpass;
